import { CatalogBase } from '../../baseBtl/catalog/products/catalog';

/**
 * The Catalog class
 * See {@link Phone} to see how it is used
 */
export abstract class Catalog extends CatalogBase {}
